import TypingIndicator from './TypingIndicator';

export default TypingIndicator;
